<template>
    <div id="article_pc">
       <TopTabs :list="$route.query.title === '名师风采' ? this.$nav21 : this.$nav22" />
      <div class="article_title">{{home.name}}</div>
      <div class="content" v-html="home.intro"></div>
      <div class="content" v-if="home.intro == ''">暂无数据...</div>
    </div>
</template>

<script>
import TopTabs from '@/components/topTabs_h5/index'
export default {
  name: 'Details',
  components: { TopTabs },
  props: {
    home: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {

    }
  },
  watch: {
    screenWidth: function (val) {
      // 监听屏幕宽度变化
      // console.log("val",val)
      this.isMaxScreen = val > 850
      // alert('ppp')
    }
  },
  computed: {
  },
  mounted () {
    this.isMaxScreen = document.body.clientWidth > 850
    window.addEventListener('resize', () => {
      // console.log('外部', document.body.clientWidth)
      this.isMaxScreen = document.body.clientWidth > 850
      // console.log("this.isMaxScreen",this.isMaxScreen)
      // console.log(99999999999999999999999999999)
    })
  },
  created () {
  },

  methods: {

  }
}
</script>

<style scoped lang="scss">
#article_pc {
   width: 100%;
  min-height: 86.5vh;
  .article_title{
    font-size: 16px;
    font-weight: 500;
    color: #000000;
    margin-bottom: 12px;
    text-align: center;
  }

  .content{
    padding: 0 4.2667vw;
    font-size: 16px;
    // text-indent: 32px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    ::v-deep p {
      line-height: 2!important;
    }
    ::v-deep img, ::v-deep video {
      display: block;
      margin: 0 auto;
      max-width: 100%!important;
      height: auto!important;
    }
  }
}

</style>
